export default __webpack_public_path__ + "static/media/app-advantages.923b714b.svg";